<template>
    <sup @click="toggle" class="relative">
        <svg class="mg-icon mg-color-primary-lighter ml-2">
            <use href="#icon-info" xlink:href="#icon-info" />
        </svg>
        <div :class="[{hidden: disabled}]" class="tooltip animated fadeInUp shade-heavier--primary-darker text-white p-6 text-base absolute pin-r p-2 rounded-lg antialiased leading-tighter w-48 z-50 base-font">{{text}}</div>
    </sup>
</template>

<script>
export default {
    props: ["text"],
    name: "tooltip",
    data() {
        return {
            disabled: true
        };
    },
    methods: {
        toggle() {
            this.disabled = !this.disabled;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/tooltip.vue